import { Form, Row, Col } from "react-bootstrap"
import InfoTooltip from '../utils/InfoTooltip';
import { properties } from '../../utils/Properties_es';
import { regexPatterns } from '../utils/regexUtils';
export default function DynamicForm({ fieldConfig, formData, handleChange, errors = {}, notClass = false, bold = false }) {
    return (
        <>
            {fieldConfig.map((row, rowIndex) => (
                <>
                    <Row className={`mb-3 pt-2 ${notClass ? '' : 'px-2 px-md-4 px-lg-5 mx-0 mx-md-3 mx-lg-5'}`}
                        key={rowIndex}>
                        {row.map((field) => (
                            <Col md={row.length === 1 ? 12 : 6} key={field.key}>
                                {field.type === "empty" ? <div></div> :
                                    <Form.Group controlId={field.key}>
                                        <Form.Label className='fs-6'>{field.label}*</Form.Label>
                                        {
                                            field.type === "radio" ? (
                                                <div className="d-flex flex-wrap gap-3">
                                                    {
                                                        field.options?.map((opt, idx) => (
                                                            <Form.Check key={idx}
                                                                type="radio"
                                                                inline
                                                                id={`${field.key}-${idx}`}
                                                                name={field.key}
                                                                label={opt.key}
                                                                value={opt.value}
                                                                checked={formData[field.key] === opt.value}
                                                                onChange={handleChange}
                                                                className="fs-6"
                                                                required={field.isRequired && idx === 0 ? true : false} />
                                                        ))}
                                                </div>

                                            )
                                                : field.type == 'select' ? (
                                                    <Form.Select
                                                        name={field.key}
                                                        value={formData[field.key]}
                                                        onChange={handleChange}
                                                        className='rounded-0'
                                                        required={field.isRequired ? true : false}
                                                        disabled={field.disabled}>
                                                        <option value="">{properties.general_select_default(field.label)}</option>
                                                        {
                                                            field.options?.map((opt, idx) => (
                                                                <option key={idx} value={opt.value}>{opt.key}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                ) : (
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <Form.Control
                                                            type={field.type}
                                                            placeholder={field.label}
                                                            name={field.key}
                                                            value={formData[field.key]}
                                                            className='rounded-0'
                                                            maxLength={field.maxCaracters ?? undefined}
                                                            style={field.type === 'text' ? { textTransform: 'uppercase' } : undefined}
                                                            onChange={(e) => {
                                                                const effectiveRegex = field.regex ?? (field.type === 'text' ? regexPatterns.noSpecialChars : null);

                                                                if (field.type === 'text') {
                                                                    e.target.value = e.target.value.toUpperCase();
                                                                }
                                                                if (field.maxCaracters && e.target.value.length > field.maxCaracters) {
                                                                    e.target.value = e.target.value.slice(0, field.maxCaracters);
                                                                }

                                                                if (effectiveRegex && !effectiveRegex.test(e.target.value)) {
                                                                    return;
                                                                }

                                                                handleChange(e);
                                                            }}
                                                            required={field.isRequired ? true : false}
                                                            disabled={field.disabled ? true : false}
                                                            onKeyDown={(e) => {
                                                                const effectiveRegex = field.regex ?? (field.type === 'text' ? regexPatterns.noSpecialChars : null);
                                                                if (effectiveRegex && !effectiveRegex.test(e.key) && e.key.length === 1) {
                                                                    e.preventDefault();
                                                                }
                                                            }}>

                                                        </Form.Control>
                                                        {
                                                            field.infoTils && (<InfoTooltip message={field.infoTils} />)
                                                        }
                                                    </div>
                                                )
                                        }
                                        {
                                            errors && errors[field.key] && (
                                                <div className="text-danger small mt-1">{errors[field.key]}</div>
                                            )
                                        }
                                    </Form.Group>}
                            </Col>
                        ))}
                    </Row>
                    {row.some((f) => f.isDivider && f.isDivider === true) && (
                        <Row className='border-bottom mx-0 mb-4 mt-5 px-0'></Row>
                    )}
                </>
            ))}
        </>
    )
}
